import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotCreateLineItemLicenseException extends  QuoteException {

}